import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  OnChanges,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
} from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { pluck } from "rxjs/operators";
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";
import saveAs from "file-saver";
import { WorkflowEmailAttachmentsComponent } from "../workflow-email-attachments/workflow-email-attachments.component";
import { lastValueFrom, Observable } from "rxjs";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { EmailTemplates } from "../../../core/models/orders/emailTemplates";
import { GetPurchaseOrderConfirmationJournalRequest } from "../../../core/models/orders/getPurchaseOrderConfirmationJournalRequest";
import { POEmailContact } from "../../../core/models/orders/poEmailContact";
import { POEmailLogs } from "../../../core/models/orders/poEmailLogs";
import { PreSalesProjectWorkflowList } from "../../../core/models/orders/preSalesProjectWorkflowList";
import { SalesOrderBCInformationDto } from "../../../core/models/orders/salesOrderBCInformation";
import { VendorInformationForPOEmailDto } from "../../../core/models/orders/vendorInformationForPOEmailDto";
import { ProjectFileDto } from "../../../core/models/project-workflow/projectFileDto";
import { WorkflowEmailData } from "../../../core/models/project-workflow/workflowEmailData";
import { GetUserProjectDto } from "../../../core/models/samplePO/details/getUserProjectDto";
import { FileUploadDto } from "../../../core/models/shared/fileUploadDto";
import { GetUserDto } from "../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { CommonService } from "../../../core/services/common.service";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderNotesSidebarService } from "../../../core/services/order-notes-sidebar.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { PoEmailService } from "../../../core/services/po-email.service";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { SaleOrderService } from "../../../core/services/sale-order.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { SharedService } from "../../../core/services/shared.service";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { EnumWorkflowEmailState } from "../../../shared/enums/workflowEmailState";
import { ClientSearchList } from "../../../core/models/shared/clientSearchList";
import { EditorComponent } from "../../../shared/components/editor/editor.component";
import { UserManagementService } from "../../../core/services/user-management.service";
import { MsalApiService } from "../../../core/services/msal-api.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { Contact } from "../../../core/models/shared/contact";
import { CommonModule } from "@angular/common";
import { WorkflowEmailContactsComponent } from "../workflow-email-contacts/workflow-email-contacts.component";
import { WorkflowEmailRecipientsComponent } from "../workflow-email-recipients/workflow-email-recipients.component";
import { WorkflowEmailHeaderComponent } from "../workflow-email-header/workflow-email-header.component";
import { DialogModule } from "primeng/dialog";
import { DividerModule } from "primeng/divider";
import { WorkflowDisplayPdfFrameComponent } from "../workflow-display-pdf-frame/workflow-display-pdf-frame.component";
import { ChatGptRequestDto } from "../../../core/models/common/chatGptRequestDto";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { PopoverModule } from "primeng/popover";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-workflow-email",
  templateUrl: "./workflow-email.component.html",
  styleUrls: ["./workflow-email.component.scss"],
  imports: [
    CommonModule,
    EditorComponent,
    WorkflowEmailContactsComponent,
    WorkflowEmailAttachmentsComponent,
    WorkflowEmailRecipientsComponent,
    WorkflowEmailHeaderComponent,
    FormsModule,
    DialogModule,
    DividerModule,
    PopoverModule,
    WorkflowDisplayPdfFrameComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    SpinnerComponent,
  ],
})
export class WorkflowEmailComponent implements OnInit, OnDestroy, OnChanges {
  poEmailForm!: FormGroup;
  workflowTemplates: EmailTemplates[] = [];
  purchaseOrderNumberList: string[] = [];
  vendorContacts: Contact[] = [];
  contacts: Contact[] = [];
  recipientsList: POEmailContact[] = [];
  loginUserInformation = {} as SalesOrderBCInformationDto;
  vendorInformation = {} as VendorInformationForPOEmailDto;
  saleOrderId = "";
  poNumber = "";
  workflowPdf = "";
  allBC: GetUserProjectDto[] = [];
  isBC = false;
  filesObject: FileUploadDto[] = [];
  totalFileSizeInKb = 0;
  bcPersonnelNumber = "";
  bacPersonnelNumber = "";
  userPersonnelNumber = "";
  userData!: GetUserDto;
  bcEmail = "";
  bacEmail = "";
  fileAttachmentUrlArray = new Map<string, string>();
  currentTemplete!: EmailTemplates;
  watermark = "";
  primaryVendorContactEmail = "";
  poJournalPdfStatus = false;
  poEmailDisplayModal = false;
  emailButtonStatus = false;
  workflowEmailScreenStatus = false;
  emailToArray: string[] = [];
  csvEmailTo = "";
  poJournalPdfUrl = "";
  workflowIdParams = 0;
  @Input() maskedWorflowId = "";
  displayRushRevisedSection = true;
  windowState = 0;
  oldTitle = "";
  customerIdD365 = "";
  clientLists: ClientSearchList[] = [];
  templateType = "";
  fileName = "";
  @ViewChild("emailComponent", { static: false })
  emailComponent!: EditorComponent;
  @Input() workflowEmailData: WorkflowEmailData = {} as WorkflowEmailData;
  displaySendButton = true;
  @Input() isAnyUnCommitLines = false;
  @Output() refreshOrderLinesGrid = new EventEmitter();
  formErrors: Record<string, string> = {
    subject: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    subject: {
      maxlength: "Subject must be less than 255 characters.",
    },
  };
  workflowId = 0;
  docusignCheck = false;
  templateBody = "";
  displayChatGPTModal = false;
  hintDailog = false;
  showSmallGPTLoader = false;
  chatGPTPrompt = "";
  projectHeaderList = [] as PreSalesProjectWorkflowList[];
  projectFilesList: ProjectFileDto[] = [];
  @ViewChild("emailAttachments", { static: false })
  emailAttachment!: WorkflowEmailAttachmentsComponent;
  fileSizeInKb = 1024;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _fb: FormBuilder,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _poEmailService: PoEmailService,
    private _msalApisService: MsalApiService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private _titleService: Title,
    private _orderSummaryService: OrderSummaryService,
    private _samplepoListingService: SamplepoListingService,
    private _orderNotesSidebarService: OrderNotesSidebarService,
    private _saleOrderService: SaleOrderService,
    private _productionWorkflowService: ProjectWorkflowService,
    private _commonService: CommonService,
    private _sharedService: SharedService
  ) {
    this.oldTitle = this._titleService.getTitle();
    // this._activatedRoute.params.subscribe((params: any) => {
    //   this.workflowIdParams = params.id;
    //   this.saleOrderId = params.saleOrderId;
    //   this.windowState = params.windowState;
    // });
    this.initializeForm();
    //this.setTitle(this.workflowIdParams.toString());
    //this.setSender();
  }

  ngOnDestroy() {
    this._titleService.setTitle(this.oldTitle);
  }

  ngOnInit() {
    this.saleOrderId = this.workflowEmailData.saleOrderId;
    this.workflowId = this.workflowEmailData.workflowId;
    this.windowState = this.workflowEmailData.windowState;
    if (this.windowState == EnumWorkflowEmailState.PrintWorkflowSummary) {
      //this.displayRushRevisedSection = false;
      this.setTitle();
    }
    this.getProjectHeaderList();
    this.setPdfFileName();
    this.getSaleOrderHeaderData(false);
    this.getWorkflowTemplates();
    //this.getAllLinePoNumber();
    this.getSalesOrderBCInformation();
    this.getUserProfile();
    this.setSender();
  }

  ngOnChanges() {
    if (this.saleOrderId) {
      //this.ngOnInit();
    }

    if (this.workflowEmailData?.windowState) {
      this.saleOrderId = this.workflowEmailData.saleOrderId;
      this.workflowIdParams = this.workflowEmailData.workflowId;
      this.windowState = this.workflowEmailData.windowState;
    }
    this.setPdfFileName();
    //this.setSender();
  }

  logValidationErrors(group: FormGroup = this.poEmailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  private initializeForm() {
    this.poEmailForm = this._fb.group({
      header: this._fb.group({
        templateId: [null],
        workflowId: [""],
        poNumberRevision: [{ value: "", disabled: true }],
        rush: [false],
        revised: [false],
        sender: [{ value: "", disabled: true }],
        subject: ["", [Validators.maxLength(255)]],
        additionalSubject: [""],
        reply: [{ value: "", disabled: true }],
        saleOrderId: [""],
      }),
    });
  }

  getWorkflowTemplates() {
    this._loaderService.setLoaderState(true);
    if (this.windowState == EnumWorkflowEmailState.PrintWorkflowSummary) {
      this.templateType = "Project-Workflow-Summary-Email";
    } else {
      this.templateType = "Project-Workflow-Summary-Email";
    }

    this._productionWorkflowService
      .getEmailTemplatesByType(this.templateType)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.workflowTemplates = res.data || [];
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getSaleOrderHeaderData(getloaderStatus: boolean) {
    if (this.saleOrderId) {
      this._loaderService.setLoaderState(getloaderStatus);
      this._orderSummaryService
        .getSaleOrderHeaderData(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              if (
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.brandingConsultantD365
              ) {
                this.bcPersonnelNumber =
                  res.data.salesOrderHeader?.salesOrderHeader?.brandingConsultantD365;
                this.getBrandingConsultantOnSaleOrder(this.userData);
              }
              if (
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.accountsCoordinatorD365
              ) {
                this.bacPersonnelNumber =
                  res.data.salesOrderHeader?.salesOrderHeader?.accountsCoordinatorD365;
              }
              if (res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365) {
                this.customerIdD365 =
                  res.data.salesOrderHeader.salesOrderHeader.customerIdD365;
                if (
                  this.windowState ==
                  EnumWorkflowEmailState.PrintWorkflowSummary
                ) {
                  this.getClientAndProspectByNameAndAccountNumberFilter();
                }
              }
            } else {
              this._toastr.error("Error", res.message || "Data not found");
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Data not found");
          },
        });
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          this.userPersonnelNumber = res?.data?.personnelNumber;
          this.getBrandingConsultantOnSaleOrder(res?.data);
        }
      },
    });
  }

  getBrandingConsultantOnSaleOrder(data: GetUserDto) {
    if (data && this.bcPersonnelNumber) {
      if (
        data?.userRoleId === UserRole.Admin ||
        data?.personnelNumber === this.bcPersonnelNumber
      ) {
        this.bcEmail = data?.sendEmailAs;
        this.bacEmail = data?.primaryBACEmail;
        this.isBC = true;
        this.poEmailForm.patchValue({
          header: {
            sender: this.bcEmail || "",
            reply: this.bcEmail || "",
          },
        });
        this.patchValueInRecipients(this.bacEmail);
        this.loginUserInformation.email = this.bcEmail;
        this.loginUserInformation.personnelNumber = data.personnelNumber;
        this.loginUserInformation.projectId = data.projectId ?? "";
        this.loginUserInformation.projectName = data.name ?? "";
        this.patchValueInEditor();
      } else {
        this.bacEmail = data?.sendEmailAs;
        this.isBC = false;
        this.poEmailForm.patchValue({
          header: {
            sender: this.bacEmail || "",
            reply: this.bacEmail || "",
          },
        });
        //this.bcEmail = data?.loginEmail;
        //this.patchValueInRecipients(this.bcEmail);
        this.getSalesOrderBCInformation();
        this.loginUserInformation.email = this.bacEmail;
        this.loginUserInformation.projectName = data.name || "";
        this.patchValueInEditor();
      }
    }
  }

  patchValueInRecipients(email: string) {
    const object = {
      id: Date.now(),
      locatorD365: email,
      descriptionD365: "",
      purposeD365: "",
      isPrimaryD365: "",
      addType: "CC",
    } as POEmailContact;
    this.recipientsList.push(object);
  }

  templatedSelected(id: number) {
    if (id > 0) {
      const index = this.workflowTemplates.findIndex(x => x.id == id);
      if (index > -1) {
        const template = this.workflowTemplates[index];
        this.currentTemplete = template;
        this.templateBody = template.body;
        //this.emailComponent.emailEditor.editor.setContent(template.body);
        if (this.vendorInformation.name) {
          this.patchValueInEditor();
        }
      }
    }
  }

  setTitle() {
    //Set titles as per the window state
    if (this.windowState == EnumWorkflowEmailState.PrintWorkflowSummary) {
      this._titleService.setTitle(`Workflow-${this.maskedWorflowId}`);
    }
  }

  getAllBC() {
    this._samplepoListingService.getAllBrandingConsultant().subscribe({
      next: res => {
        if (res.status.toLowerCase() == "success") {
          this.allBC = res.data;
          const index = this.allBC.findIndex(
            x => x.personnelNumber == this.loginUserInformation.personnelNumber
          );
          if (index > -1) {
            this.isBC = true;
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  setSender() {
    this.poEmailForm.patchValue({
      header: {
        sender: this.bcEmail,
      },
    });
  }

  getSalesOrderBCInformation() {
    this._poEmailService
      .getSalesOrderBCInformation(this.saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.bcEmail = res.data.email;
            this.patchValueInRecipients(this.bcEmail);
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getVendorInformationForPOEmail(poNumber: string) {
    this.emailButtonStatus = false;
    //this._loaderService.setLoaderState(true);
    this.poNumber = poNumber;
    if (this.poNumber) {
      if (this.poEmailForm.get(["header", "rush"])?.value) {
        this._orderSummaryService
          .printPOForSalesOrder(poNumber, "Rush")
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.workflowPdf = res.data;

                if (this.workflowPdf) {
                  this.emailButtonStatus = true;
                }
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      } else if (this.poEmailForm.get(["header", "revised"])?.value) {
        this._orderSummaryService
          .printPOForSalesOrder(poNumber, "Revised")
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.workflowPdf = res.data;

                if (this.workflowPdf) {
                  this.emailButtonStatus = true;
                }
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      } else {
        this._orderSummaryService.printPOForSalesOrder(poNumber).subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.workflowPdf = res.data;

              if (this.workflowPdf) {
                this.emailButtonStatus = true;
              }
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
      }

      this._saleOrderService
        .getVendorInformationForPOEmail(poNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.vendorInformation = res.data;
            this.patchValueInEditor();
            if (res.status.toLowerCase() == "success") {
              this.getAllContactsByAccountNumber(
                this.vendorInformation.vendorAccountNumber,
                this.vendorInformation.partyNumber
              );
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });

      const poNumberObject: GetPurchaseOrderConfirmationJournalRequest = {
        purchaseOrderID: poNumber,
      };
      this._poEmailService
        .GetPurchaseOrderConfirmationJournal(poNumberObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.poEmailForm.patchValue({
                header: { poNumberRevision: res?.data?.PurchaseJournal ?? "" },
              });
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  getAllContactsByAccountNumber(accountNumber: string, partyNumber = "") {
    this._saleOrderService
      .getAllContactsByAccountNumber(accountNumber, partyNumber)
      .pipe(pluck("data"))
      .subscribe({
        next: data => {
          this.contacts = data.filter(
            x => x.typeD365?.toLowerCase() == "email"
          );
          this.vendorContacts = JSON.parse(JSON.stringify(this.contacts));
          const primaryContact = this.contacts.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" &&
              x.purposeD365?.toLowerCase()?.includes("business")
          );
          if (primaryContact.length > 0) {
            const object = {
              locatorD365: primaryContact[0].locatorD365,
              descriptionD365: primaryContact[0].descriptionD365,
              purposeD365: primaryContact[0].purposeD365,
              isPrimaryD365: primaryContact[0].isPrimaryD365,
              addType: "TO",
            } as POEmailContact;
            this.primaryVendorContactEmail =
              primaryContact[0].locatorD365 ?? "";
            this.recipientsList.push(object);
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  addCC(addCCList: Contact[]) {
    addCCList.forEach(x => {
      // if (!this.isValidEmail(x.locatorD365)) {
      //   this._toastr.error('Invalid Email', 'Error');
      //   return;
      // }
      const index = this.vendorContacts.findIndex(a => a.id == x.id);
      if (index > -1) {
        this.vendorContacts.splice(index, 1);
      }
      this.recipientsList.push({ ...x, addType: "CC" } as POEmailContact);
    });
  }

  addTO(addTOList: Contact[]) {
    addTOList.forEach(x => {
      // if (!this.isValidEmail(x.locatorD365)) {
      //   this._toastr.error('Invalid Email', 'Error');
      //   return;
      // }
      const index = this.vendorContacts.findIndex(a => a.id == x.id);
      if (index > -1) {
        this.vendorContacts.splice(index, 1);
      }
      this.recipientsList.push({ ...x, addType: "TO" } as POEmailContact);
    });
  }

  recipientsDeleted(deletedList: POEmailContact[]) {
    for (const contact of deletedList) {
      const index = this.recipientsList.findIndex(x => x.id == contact.id);
      if (index > -1) {
        this.recipientsList.splice(index, 1);
      }
      if (this.contacts.findIndex(x => x.id == contact.id) > -1) {
        this.vendorContacts.push(contact);
      }
    }
  }

  recipientsAdd() {
    //const userJson = localStorage.getItem('user') || '';
    //const userObject = JSON.parse(userJson);
    //const useremail = userObject?.account?.username || '';
    this.recipientsList.push({
      id: Date.now(),
      addType: "CC",
      locatorD365: "",
      firstNameD365: "",
      lastNameD365: "",
      typeD365: "",
      createdDate: new Date().toISOString(),
      createdBy: this.bcEmail,
      lastModifiedDate: new Date().toISOString(),
      lastModifiedBy: this.bcEmail,
      isActive: true,
      descriptionD365: undefined,
      otherSpecification: "",
    });
  }

  patchValueInEditor() {
    let content = this.templateBody; //this.emailComponent?.emailEditor?.editor?.getContent();
    if (content) {
      if (this.windowState == EnumWorkflowEmailState.PrintWorkflowSummary) {
        content = content.replace(
          "#{ClientName}",
          this.vendorInformation?.name
        );
        content = content.replace("{SalesOrder}", this.saleOrderId);
        content = content.replace(
          "#{currentUser}",
          this.userData?.displayEmailAs || ""
        );
        content = content.replace("#{BCName}", this.userData?.name || "");
        content = content.replace("{WorklfowId}", this.maskedWorflowId || "");
        this.templateBody = content;
        //this.emailComponent.emailEditor.editor.setContent(content);
      }
    }
  }

  getAttachmentFileArray(event: FileUploadDto[]) {
    this.filesObject = event;
  }

  getTotalFileSize(event: number) {
    this.totalFileSizeInKb = event;
  }

  submitButtonlogValidationErrors(group: FormGroup = this.poEmailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  attachmentFileUrlArray(fileUrl: Map<string, string>) {
    this.fileAttachmentUrlArray = fileUrl;
  }

  getBase64ForOrder(base64: string) {
    this.workflowPdf = base64;
  }

  async sendEmail(content: string) {
    this._loaderService.setLoaderState(true);
    this.submitButtonlogValidationErrors();
    this.csvEmailTo = "";
    if (!this.poEmailForm.valid) {
      return;
    }

    if (this.filesObject.length >= 250) {
      this._toastr.error(`File attachments must be less than 250`, "Error");
      return;
    }

    if (this.totalFileSizeInKb >= 33000) {
      this._toastr.error(
        `Total file attachments size must be less than 33MB`,
        "Error"
      );
      return;
    }

    const attachmentObject = {
      base64: this.workflowPdf,
      fileExtension: ".pdf",
      fileId: 1,
      fileMimeType: "application/pdf",
      fileName: `${this.poNumber}.pdf`,
    } as FileUploadDto;
    const res = await lastValueFrom(
      this._poEmailService.getPoEmailAttachmentUrl(attachmentObject)
    );
    this.poJournalPdfUrl = res.data;

    const toRecipients: MicrosoftGraph.Recipient[] = [];
    const ccRecipients: MicrosoftGraph.Recipient[] = [];
    const to = this.recipientsList.filter(x => x.addType == "TO");
    const cc = this.recipientsList.filter(x => x.addType == "CC");

    for (const x of to) {
      if (!this.isValidEmail(x.locatorD365 ?? "")) {
        this._toastr.error(`Invalid Email ${x.locatorD365}`, "Error");
        this._loaderService.setLoaderState(false);
        return;
      }
    }
    for (const x of cc) {
      if (!this.isValidEmail(x.locatorD365 ?? "")) {
        this._toastr.error(`Invalid Email ${x.locatorD365}`, "Error");
        this._loaderService.setLoaderState(false);
        return;
      }
    }

    to.forEach(x => {
      toRecipients.push({
        emailAddress: {
          address: x.locatorD365,
          name: x.descriptionD365 ?? undefined,
        },
      });
    });
    cc.forEach(x => {
      ccRecipients.push({
        emailAddress: {
          address: x.locatorD365,
          name: x.descriptionD365 ?? undefined,
        },
      });
    });

    this.setPdfFileName();

    const attachement: MicrosoftGraph.Attachment[] = [];
    attachement.push({
      contentBytes: this.workflowPdf,
      name: this.fileName,
      contentType: "application/pdf",
      "@odata.type": "#microsoft.graph.fileAttachment",
    } as MicrosoftGraph.Attachment);

    if (this.filesObject.length > 0) {
      for (const key in this.filesObject) {
        attachement.push({
          contentBytes: this.filesObject[key].base64,
          name: `${this.filesObject[key].fileName}`,
          contentType: this.filesObject[key].fileMimeType,
          "@odata.type": "#microsoft.graph.fileAttachment",
        } as MicrosoftGraph.Attachment);
      }
    }

    let mailMessage: MicrosoftGraph.Message = {};
    if (this.isBC) {
      const replyTo: MicrosoftGraph.Recipient[] = [
        {
          emailAddress: {
            address: this.loginUserInformation.email,
            name: this.loginUserInformation.projectName,
          },
        },
      ];

      mailMessage = {
        subject: this.poEmailForm.get(["header", "subject"])?.value || "",
        body: {
          contentType: "html",
          content: content,
        },
        toRecipients: toRecipients,
        ccRecipients: ccRecipients,
        replyTo: replyTo,
        attachments: attachement,
      };
    } else {
      const replyTo: MicrosoftGraph.Recipient[] = [
        {
          emailAddress: {
            address: this.loginUserInformation.email,
            name: this.loginUserInformation.projectName,
          },
        },
      ];
      mailMessage = {
        subject: this.poEmailForm.get(["header", "subject"])?.value || "",
        body: {
          contentType: "html",
          content: content,
        },
        toRecipients: toRecipients,
        ccRecipients: ccRecipients,
        attachments: attachement,
        replyTo: replyTo,
      };
    }

    const mail = {
      message: mailMessage,
    };

    //this._loaderService.setLoaderState(true);
    this.displaySendButton = false;
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.success("Email Sent Successfully", "Success");
        this.sendEmailsLog(content, ccRecipients, toRecipients);
        //const emails = [...toRecipients, ...ccRecipients];
        //this.orderNotes(emails);
      },
      error: err => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          err?.error?.error?.message || "Unable To Send Mail",
          "Error"
        );
        this.displaySendButton = true;
      },
    });
  }

  sendEmailsLog(
    content: string,
    cc: MicrosoftGraph.Recipient[],
    to: MicrosoftGraph.Recipient[]
  ) {
    const attachementsArray = Array.from(this.fileAttachmentUrlArray).map(
      ([key, value]) => ({
        key,
        value,
      })
    );

    if (this.poJournalPdfUrl) {
      attachementsArray.push({
        key: `${this.poNumber}.pdf`,
        value: this.poJournalPdfUrl,
      });
    }

    const rush = this.poEmailForm.get(["header", "rush"])?.value;
    const revised = this.poEmailForm.get(["header", "revised"])?.value;
    if (rush && revised) {
      this.watermark = "All";
    } else if (rush) {
      this.watermark = "Rush";
    } else if (revised) {
      this.watermark = "Revised";
    } else {
      this.watermark = "";
    }

    const poEmailLogs = {
      templateId: this.currentTemplete?.id,
      additionalSubject: this.poEmailForm.get(["header", "additionalSubject"])
        ?.value,
      templateName: this.currentTemplete?.name,
      poNumber: this.poEmailForm.get(["header", "poNumber"])?.value,
      sender: this.poEmailForm.get(["header", "sender"])?.value,
      reply: this.poEmailForm.get(["header", "reply"])?.value,
      subject: this.poEmailForm.get(["header", "subject"])?.value,
      poRevisedVersion:
        this.poEmailForm.get(["header", "poNumberRevision"])?.value || "",
      attachement: JSON.stringify(attachementsArray),
      body: content,
      cc: JSON.stringify(cc),
      to: JSON.stringify(to),
      from: this.poEmailForm.get(["header", "sender"])?.value,
      id: 0,
      watermark: this.watermark,
    } as POEmailLogs;

    this._poEmailService.createPOEmailLogs(poEmailLogs).subscribe();
  }

  // orderNotes(to: any) {
  //   this.emailToArray = [];
  //   if (to.length > 0) {
  //     for (const x of to) {
  //       if (x.emailAddress.address) {
  //         this.emailToArray.push(x.emailAddress.address);
  //       }
  //     }
  //     if (this.emailToArray.length > 0) {
  //       this.csvEmailTo = this.emailToArray.toString();
  //     }
  //   }

  //   const rush = this.poEmailForm.get(['header', 'rush'])?.value;
  //   const revised = this.poEmailForm.get(['header', 'revised'])?.value;
  //   if (rush && revised) {
  //     this.watermark = 'Rush Revised';
  //   } else if (rush) {
  //     this.watermark = 'Rush';
  //   } else if (revised) {
  //     this.watermark = 'Revised';
  //   } else {
  //     this.watermark = '';
  //   }

  //   const saleOrderFormObject = {
  //     type: 'Order notes',
  //     purchaseOrderId:
  //       this.poEmailForm.get(['header', 'poNumber'])?.value || '',
  //     description:
  //       this.watermark !== ''
  //         ? `${this.watermark} ${this.csvEmailTo}`
  //         : this.csvEmailTo,
  //     note: this.primaryVendorContactEmail
  //       ? `To ${this.primaryVendorContactEmail}`
  //       : '',
  //     id: 0,
  //     purchaseOrderStatus: true
  //   } as SalesOrderNotes;

  //   if (this.saleOrderId) {
  //     saleOrderFormObject.salesOrderId = this.saleOrderId;
  //     saleOrderFormObject.portalKey = uuidv4();
  //   }

  //   this._orderNotesSidebarService
  //     .AddSalesOrderNotes(saleOrderFormObject)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: () => {
  //         this._loaderService.setLoaderState(false);
  //       },
  //       error: () => {
  //         this._loaderService.setLoaderState(false);
  //       }
  //     });
  // }

  isValidEmail(email: string): boolean {
    const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
    if (RegExp(regex).exec(email)) {
      return true;
    }
    return false;
  }

  sendEmailEvent() {
    if (this.workflowPdf) {
      this.poEmailDisplayModal = true;
    }
  }

  closeModal() {
    this.poEmailDisplayModal = false;
  }

  fetchWatermarkedPdf(watermark: { rush: boolean; revised: boolean }) {
    this._loaderService.setLoaderState(true);
    if (watermark.revised && watermark.rush) {
      this._loaderService.setLoaderState(false);
    } else if (watermark.rush) {
      this._orderSummaryService
        .printPOForSalesOrder(this.poNumber, "Rush")
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.workflowPdf = res.data;
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    } else if (watermark.revised) {
      this._orderSummaryService
        .printPOForSalesOrder(this.poNumber, "Revised")
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.workflowPdf = res.data;
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  emailSelection() {
    this.workflowEmailScreenStatus = true;
  }

  getClientAndProspectByNameAndAccountNumberFilter() {
    this._loaderService.setLoaderState(true);
    this._samplepoListingService
      .getClientAndProspectByNameAndAccountNumberFilter(this.customerIdD365)
      .subscribe({
        next: res => {
          if (res.data != null) {
            this._loaderService.setLoaderState(false);
            this.clientLists = res.data;

            if (this.clientLists[0]?.partyNumber) {
              this.vendorInformation.name = this.clientLists[0].name ?? "";
              this.getAllContactsByAccountNumber(
                this.customerIdD365,
                this.clientLists[0]?.partyNumber
              );
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  setPdfFileName() {
    if (this.windowState == EnumWorkflowEmailState.PrintWorkflowSummary) {
      this.fileName = `Project Summary-${this.workflowId}.pdf`;
    } else {
      this.fileName = this.workflowId
        ? `${this.workflowId}.pdf`
        : `${this.workflowIdParams}.pdf`;
    }
  }

  refreshOrderLinesGridEvent() {
    this.refreshOrderLinesGrid.emit();
  }

  isDocusignChecked(event: boolean) {
    this.docusignCheck = event;
  }

  showOrHideChatGPTModal() {
    this.displayChatGPTModal = !this.displayChatGPTModal;
  }

  showChatGptHintDialog() {
    this.hintDailog = !this.hintDailog;
  }

  postChatGPTRequest() {
    this.showSmallGPTLoader = true;
    if (!this.chatGPTPrompt || this.chatGPTPrompt === "") {
      this._toastr.error("Error", "Prompt cannot be empty");
      this.showSmallGPTLoader = false;
      return;
    }

    const payload = {
      messages: [
        {
          role: "user",
          content: this.chatGPTPrompt,
        },
      ],
    } as ChatGptRequestDto;
    this._commonService.postChatGPTRequest(payload).subscribe({
      next: res => {
        if (res?.data) {
          this.templateBody = res?.data;
        }
        this.chatGPTPrompt = "";
        this.displayChatGPTModal = false;
        this.showSmallGPTLoader = false;
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Data from Chat GPT");
        this.displayChatGPTModal = true;
        this.showSmallGPTLoader = false;
      },
    });
  }

  projectSummaryExcelDownload() {
    this._loaderService.setLoaderState(true);
    this._productionWorkflowService
      .projectSummaryExcelDownload(this.workflowId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res?.data) {
            this.downloadExcelFile(this.b64toBlob(res.data)); //, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'));
          } else {
            this._toastr.error(
              "Error",
              "Failed to download Project Summary Excel Sheet"
            );
          }
        },
        error: () => {
          this._toastr.error(
            "Error",
            "Failed to download Project Summary Excel Sheet"
          );
          this._loaderService.setLoaderState(false);
        },
      });
  }

  downloadExcelFile(data: Uint8Array<ArrayBuffer>[]) {
    const file = new Blob(data, {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      file,
      `Project-Summary-Excel-${this.workflowId.toString().padStart(6, "0")}.xlsx`
    );
  }

  b64toBlob(b64Data: string, sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return byteArrays;
  }

  getProjectHeaderList() {
    this._productionWorkflowService
      .getProjectHeaderList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.projectHeaderList = res.data;
          } else {
            this.projectHeaderList = [];
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to Project List");
        },
      });
  }

  getProjectFilesList(projectId: number) {
    this.projectFilesList = [];
    this._loaderService.setLoaderState(true);
    this._productionWorkflowService
      .getProjectFiles(projectId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.projectFilesList = res.data;
          } else {
            this.projectFilesList = [];
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "Unable to get Project Files");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onProjectFileAddEvent(event: ProjectFileDto) {
    this._loaderService.setLoaderState(true);
    if (this.emailAttachment) {
      const fileDto: FileUploadDto = {
        fileName: event.fileName,
        fileId: event.fileId,
        fileExtension: this.getFileExtension(event.fileName),
        base64: "",
        fileMimeType: "",
        fileSize: 0,
        fileSizeName: "",
      };
      this._sharedService
        .getFileAsBlob(event.fileUrl)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res) {
              fileDto.fileMimeType = res.type;
              fileDto.fileSizeName = this.emailAttachment.formatBytes(res.size); // file Size in MB
              fileDto.fileSize = Math.round(res.size / this.fileSizeInKb);
              this.getFileBase64Data(fileDto, res, event.fileUrl);
              //this.emailAttachment.addProjectFile(fileDto, event.fileUrl);
            }
          },
          error: () => {
            this._toastr.error("Error", "Unable to Add Project File");
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  convertBlobToBase64(blob: Blob): Observable<string> {
    return new Observable(observer => {
      const reader = new FileReader();

      reader.onloadend = () => {
        const result = reader.result as string;
        const base64String = result.split(",")[1]; // Remove the prefix
        observer.next(base64String); // Emit only the Base64 string
        observer.complete(); // Signal that the observable has completed
      };

      reader.onerror = error => {
        observer.error(error); // Emit an error if one occurs
      };

      reader.readAsDataURL(blob); // Read the Blob as a Base64 string
    });
  }

  getFileExtension(filename: string): string {
    const lastDotIndex = filename.lastIndexOf(".");

    if (lastDotIndex === -1 || lastDotIndex === filename.length - 1) {
      // No dot found or dot is the last character (no extension)
      return "";
    }

    return filename.substring(lastDotIndex + 1) ?? "";
  }

  getFileBase64Data(file: FileUploadDto, blob: Blob, fileUrl: string) {
    this.convertBlobToBase64(blob)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: string | null) => {
          file.base64 = res ?? "";
          if (this.emailAttachment) {
            this.emailAttachment.addProjectFile(file, fileUrl);
          } else {
            this._toastr.error("Error", "Unable to add File" + file.fileName);
            this._loaderService.setLoaderState(false);
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to add File" + file.fileName);
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
